<template>
  <v-container class="sponsors none-fluid link">
    <banner>Sponsors</banner>
    <anchor-bar :data="sponsors" />
    <br />
    <v-expansion-panels
      multiple
      v-model="panels"
      class="mx-auto sponsors-content"
    >
      <v-expansion-panel
        v-for="section in sponsors"
        :key="section.title"
        expand
        :id="section.title.replace(/\s/gi, '-')"
      >
        <v-expansion-panel-header class="expansion-header">{{
          section.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="expansion-content">
          <div
            v-for="content in section.grants"
            :key="content"
            v-html="$sanitize(content)"
            class="expansion-subsection"
          ></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";
import AnchorBar from "../global/AnchorBar";
import { getAllSponsors } from "../../service/research/sponsors";

export default {
  components: {
    Banner,
    AnchorBar,
  },
  data() {
    return {
      sponsors: [],
      panels: [],
    };
  },
  mounted() {
    getAllSponsors()
      .then((sponsors) => {
        this.sponsors = sponsors;
        for (let i = 0; i < sponsors.length; ++i) {
          this.panels.push(i);
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
};
</script>